import moment from "moment";
import { checkStatusExpiry } from "../common/checkStatusExpiry";
import StatusEnum from "../common/StatusEnum";

export const getBaseStationData = async (
  dynamoDBClient,
  id = "",
  email = ""
) => {
  const batchParams = {
    RequestItems: {
      GatewayData: {
        Keys: [
          {
            Email: email,
            GatewayMAC: id,
          },
        ],
      },
      Gateways: {
        Keys: [
          {
            Email: email,
            GatewayMAC: id,
          },
        ],
        ProjectionExpression:
          "GatewayLocation, WifiSettings, QRCode, GatewayMAC, Firmware,Email",
      },
    },
  };

  try {
    const data2 = await dynamoDBClient.batchGet(batchParams).promise();
    const result1 = data2?.Responses?.GatewayData[0];
    const result2 = data2.Responses.Gateways[0];
    if (result2) {
      let status;
      if (result1) {
        const isGreaterTime = checkStatusExpiry(result1?.DateUpdated);
        if (isGreaterTime) {
          status = StatusEnum.offline;
        } else {
          status = StatusEnum.online;
        }
      } else {
        status = StatusEnum.offline;
      }

      const finalResult = [{ ...result2, status }];
      return finalResult;
    } else {
      return [];
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getLatestBaseStationRecords = async (
  dynamoDBClient,
  id = "",
  email = ""
) => {
  try {
    let lastEvaluatedKey = null;
    let result = [];
    do {
      const params = {
        TableName: "Notifications",
        KeyConditionExpression: "Email = :email",
        FilterExpression: "GatewayMAC = :gatewayMac",
        ExpressionAttributeValues: {
          ":email": email,
          ":gatewayMac": id,
        },
        ProjectionExpression:
          "NotificationTimeStamp, NotificationReason, RecordTimeStamp",
        ExculsiveStartKey: lastEvaluatedKey,
      };
      const data = await dynamoDBClient.query(params).promise();
      console.log(data);
      let arr = data.Items;
      lastEvaluatedKey = data.LastEvaluatedKey;
      arr = arr.sort((a, b) =>
        moment(b.NotificationTimeStamp).diff(a.NotificationTimeStamp)
      );
      result.push(...arr);
    } while (lastEvaluatedKey);

    return result;
  } catch (error) {
    throw new Error(error);
  }
};

export const getActiveBeaconCountStatus1 = async (
  dynamoDBClient,
  id = "",
  email = ""
) => {
  try {
    const params = {
      TableName: "BeaconData",
      FilterExpression: "Email = :email and GatewayMac = :gatewayMac",
      ExpressionAttributeValues: {
        ":email": email,
        ":gatewayMac": id,
      },
      ProjectionExpression: "DateUpdated, BeaconMAC",
    };

    const data = await dynamoDBClient.scan(params).promise();
    const arr = data.Items;
    if (arr.length === 0) {
      return false;
    }
    const params2 = {
      TableName: "Beacons",
      FilterExpression: "Email = :email",
      ExpressionAttributeValues: {
        ":email": email,
      },
      ProjectionExpression: "BeaconMAC",
    };

    const data2 = await dynamoDBClient.scan(params2).promise();
    const arr2 = data2.Items;
    if (arr2.length === 0) {
      return false;
    }

    const beaconData = arr.filter((obj1) =>
      arr2.some((obj2) => obj1.BeaconMAC === obj2.BeaconMAC)
    );

    return beaconData;
  } catch (error) {
    throw new Error(error);
  }
};

export const getActiveBeaconCountStatus = async (
  dynamoDBClient,
  email = "",
  arr = []
) => {
  const beaconData = [];

  try {
    if (arr.length > 0) {
      const snoozeParams = {
        TableName: "SnoozeSettings",
        FilterExpression: "Email = :email",
        ExpressionAttributeValues: {
          ":email": email,
        },
        ProjectionExpression:
          "SnoozeTimeStampEnd , SnoozeTimeStampStart, BeaconMAC",
      };

      const snoozeResult = await dynamoDBClient.scan(snoozeParams).promise();

      const result = snoozeResult.Items;
      await Promise.all(
        arr.map(async (element) => {
          if (snoozeResult.Count > 0) {
            const data3 = result.filter(
              (snoozeItem) => snoozeItem.BeaconMAC === element.BeaconMAC
            );

            if (data3.length > 0) {
              const snooze = data3[0];
              const now = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
              const isBetween = moment(now).isBetween(
                snooze.SnoozeTimeStampStart,
                snooze.SnoozeTimeStampEnd
              );

              if (isBetween) {
                beaconData.push({
                  DateUpdated: element.DateUpdated,
                  BeaconStatus: StatusEnum.snoozed,
                });
              } else {
                beaconData.push({
                  DateUpdated: element.DateUpdated,
                  BeaconStatus: StatusEnum.online,
                });
              }
            } else {
              beaconData.push({
                DateUpdated: element.DateUpdated,
                BeaconStatus: StatusEnum.online,
              });
            }
          } else {
            beaconData.push({
              DateUpdated: element.DateUpdated,
              BeaconStatus: StatusEnum.online,
            });
          }
        })
      );
    }

    return beaconData;
  } catch (error) {
    throw new Error(error);
  }
};

export const getBaseStationWarranty = async (dynamoDBClient, id = "") => {
  try {
    const params = {
      TableName: "BeaconData",
      FilterExpression: "GatewayMAC = :gatewayMac",
      ExpressionAttributeValues: {
        ":gatewayMac": id,
      },
    };
    const data = await dynamoDBClient.scan(params).promise();

    return "";
  } catch (error) {
    throw new Error();
  }
};
